import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ModalService} from "../../../../../../../services/modal.service";
import {Api, ApiService} from "../../../../../../../../common/services/api.service";
import {ToastService} from "../../../../../../../../common/services/toast.service";
import {UserService} from "../../../../../../../../common/services/user.service";
import {StorageService} from "../../../../../../../../common/services/storage.service";
import {AbstractOrderItemComponent} from "../../../item/item";
import {SpinnerService} from "../../../../../../../../common/services/spinner.service";
import {api} from "jsbarcode";
import {Api3Service} from "../../../../../../../../common/services/api3.service";
import {HelpersService} from "../../../../../../../../common/services/helpers.service";
import { PartMasterService } from "src/modules/common/services/part-master.service";


@Component({
    selector: "section-order-wizard-item-sales",
    templateUrl: "../../../item/item.component.html",
    styleUrls: [
        "../../../item/item.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class OrderWizardItemSalesComponent extends AbstractOrderItemComponent implements OnInit {

    public itemType: string = "outbound";

    public formType: string = "sales";

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected apiService: ApiService,
        protected api3Service: Api3Service,
        protected toastService: ToastService,
        protected modalService: ModalService,
        protected userService: UserService,
        protected storageService: StorageService,
        protected spinnerService: SpinnerService,
        protected helpersService: HelpersService,
        protected partMasterService: PartMasterService,
    ) {
        super(changeDetectorRef, apiService, api3Service, toastService, modalService, userService, storageService,
            spinnerService, helpersService, partMasterService);
    }

    public onItemSelected($event: any): void {
        super.onItemSelected($event);
        if (this.outboundHubRef) {
            this.outboundHubRef.getHubs();
        }
    }

    public showOutboundHubSelect(): boolean {
        return true;
    }

    public showInboundHubSelect(): boolean {
        return false;
    }

    /**
     * Add item (prepare & add modal response)
     */
    public async save(): Promise<any> {
        this.spinnerService.show();

        const {code, message}: Api.IResponse = await this.api3Service.post(
            `${this.modal.params.state.section}/order-items`, {
                items: [
                    {
                        ...this.formGroup.value,
                        hub_id: this.formGroup.value.outbound_hub_id,
                        order_id: this.modal.params.order_id,
                        type: "outbound"
                    }
                ]
            });

        this.spinnerService.hide();

        this.storageService.set("add_order", {
            hub_id: this.formGroup.value.outbound_hub_id
        });

        this.modal.response.next({
            name: "value",
            value: true
        });

        if (code === 200) {
            this.toastService.show(message, "success");
        }
    }

    public ngOnInit(): void {
        this.formGroup.get("inbound_hub_id").clearValidators();
        this.formGroup.get("inbound_hub_id").updateValueAndValidity();
        super.ngOnInit();
        this.disable_hub_select = !!this.modal.params.disable_hub_select && this.formGroup.value.outbound_hub_id;
    }
}